<template>
	<div>

        <page-title-bar></page-title-bar>
		<app-section-loader :status="loader"></app-section-loader>

			<v-container fluid grid-list-xl py-0>
 
			<v-layout row wrap>
				<app-card
					:fullBlock="true"
					colClasses="xl6 lg9 md9 sm12 xs12 xs12 xs12"
				>
                    <div class="text-xs-right">
                        <v-btn color="success" @click="newRec()" name="btnsave" class="text-xs-right">Nieuw</v-btn>
                    </div>
					<v-card-title>Online pakketten
						<v-spacer></v-spacer>
						<v-text-field
							append-icon="search"
							label="Search"
							single-line
							hide-details
							v-model="search"
						>
						</v-text-field>
					</v-card-title>
					<v-data-table
						v-bind:headers="headers"
						v-bind:items="items"
						:rows-per-page-items="rowsPerPageItems" :pagination.sync="pagination"
					>
						<template slot="items" slot-scope="props">
							<td>{{ props.item.Descr }} </td>
						  <td class="text-xs-center"><v-btn icon  @click="askDel (props.item)"><v-icon small>delete</v-icon></v-btn></td>
							<td class="text-xs-center"><v-btn icon  @click="editRec (props.item)"><v-icon small>edit</v-icon></v-btn></td>
						</template>
						<template slot="pageText" slot-scope="{ pageStart, pageStop }">
							From {{ pageStart }} to {{ pageStop }}
						</template>
					</v-data-table>
				</app-card>

					<v-dialog v-model="dialog2" max-width="500">
						<v-card>
							<v-card-title class="headline">Pakket verwijderen?</v-card-title>
							<v-card-text>Ben je zeker dat je <strong> {{this.currentRec.Descr}} </strong> wenst te verwijderen ?</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="warning" flat="flat" @click.native="dialog2 = false">Nee</v-btn>
								<v-btn color="error" flat="flat" @click.native="delRec(currentRec)">Ja</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>

					<v-dialog v-model="dlgError" max-width="500">
						<v-card>
							<v-card-title class="headline">Fout</v-card-title>
							<v-card-text>{{errormsg}}</v-card-text>
							<v-card-actions>
								<v-spacer></v-spacer>
								<v-btn color="warning" flat="flat" @click.native="dlgError = false">OK</v-btn>
							</v-card-actions>
						</v-card>
					</v-dialog>

			</v-layout>
  	</v-container>
	</div>
</template>

<script>
// charts component
import myHttpApi from "../../api/myHttpApi";
import router from '../../router';

export default {
  components: {
		
	},
  data() {
    return {
	    dialog2: false,
        currentRec : '',
        loader: true,
        errormsg: '',
        dlgError: false,
        max25chars: v => v.length <= 25 || "Input too long!",
        tmp: "",
        search: "",
			pagination: {},
			categories: [],
        headers: [
            { text: "Naam", value: "Descr", width: "80%" }
        ],
		items: [],
		rowsPerPageItems: [10, 20, 30, 40],
        pagination: {
            rowsPerPage: 10
        }
    };
  },
   mounted() {
	
	this.getRemoteData();
  },
  methods: {
    getRemoteData() {
			myHttpApi
			
		myHttpApi.post('BOSettings/GetPackages', "")
        .then(response => {
            this.loader = false;
            this.items =  response.data;
        })
        .catch(error => {
          console.log(error);
        });
    },
    askDel(rec){
        this.currentRec = rec;
        this.dialog2 = true;
    },
        editRec(rec){
            self.currentRec = rec;
            router.push({name:'packagedet', params: {id: rec.PackageID} });
    },
    newRec(){
            this.currentRec = [];
            router.push({name:'packagedet', params: {id: '00000000-0000-0000-0000-000000000000', isNew: true } });
    },
    delRec(rec){
			 self.currentRec = rec;
			 myHttpApi.post( 'BOSettings/DelPackage', rec)
        .then(response => {
				this.loader = false;
				this.dialog2 = false;
                this.getRemoteData();
        })
        .catch(error => {
			console.log(error);
        });
    },
  }
};
</script>
